import { usePrevious } from 'react-use';
import { useEffect, useMemo } from 'react';
import { useVirtualizer } from '@tanstack/react-virtual';

interface UseScrollToLatestVirtualThreadMessageArgs<E extends HTMLElement> {
  messagesLength: number;
  virtualizer: ReturnType<typeof useVirtualizer<E, Element>>;
}

export function useScrollToLatestVirtualThreadMessage<E extends HTMLElement>({
  messagesLength,virtualizer,
}: UseScrollToLatestVirtualThreadMessageArgs<E>) {
  const prevMessagesLength = usePrevious(messagesLength);
  const lastIndex = useMemo(() => virtualizer.options.count - 1, [virtualizer.options.count]);

  // Scroll to bottom when messagesLength changes
  useEffect(() => {
    if (prevMessagesLength !== messagesLength) {
      virtualizer.scrollToIndex(lastIndex, { behavior: 'auto', align: 'start', });
    }
  }, [messagesLength, prevMessagesLength]);

}
